import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import AiCoding from './pages/AiCoding';
import AiCreation from './pages/AiCreation';
import Knowledge from './pages/Knowledge';
import About from './pages/About';
import GlobalStyles from './styles/GlobalStyles';

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <GlobalStyles />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ai-coding" element={<AiCoding />} />
            <Route path="/ai-creation" element={<AiCreation />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </Layout>
      </Router>
    </ConfigProvider>
  );
};

export default App;
